import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSalesSummary() {
	return client.get('tunnel/api/stockist/dashboard/sales_by_month');
}

function getTotalSales() {
	return client.get('tunnel/api/stockist/dashboard/total_sales');
}

function getpickupToday() {
	return client.get('tunnel/api/stockist/transaction/pickuptoday');
}

function getShipping() {
	return client.get('tunnel/api/stockist/transaction/shipping',{
		params : {
			limit : 200
		}
	});
}

export default {
	getSalesSummary,
	getTotalSales,
	getpickupToday,
	getShipping
}